import React from 'react';

/**
 * LidyAi bot avatari — kafa formu: yuvarlak koseli mavi kafa, koyu vizor,
 * turuncu gulus ve anten topu. Tek bilesen olarak FAB (58px),
 * mesaj avatari (24px) ve yaziyor gostergesinde (24px) kullanilir.
 *
 * viewBox cizimin gercek sinirlarina yakin tutuldu (x 8..112, y 0..104) —
 * boylece robot verilen `size` kutusunu neredeyse tamamen doldurur.
 * Daha kucuk gostermek icin viewBox'i genislet (or. "0 0 120 120").
 */
const RobotIcon = ({ size = 55 }) => (
  <svg
    width={size}
    height={size}
    viewBox="8 0 104 104"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Anten */}
    <line x1="60" y1="18" x2="60" y2="32" stroke="#3E9BC7" strokeWidth="4" strokeLinecap="round" />
    <circle cx="60" cy="12" r="7" fill="#F7844F" />

    {/* Kulaklar (kafanin arkasinda kalsin diye kafadan once) */}
    <rect x="11" y="52" width="13" height="26" rx="6.5" fill="#1F6CE0" />
    <rect x="96" y="52" width="13" height="26" rx="6.5" fill="#1F6CE0" />

    {/* Kafa */}
    <rect x="22" y="28" width="76" height="70" rx="24" fill="url(#headGrad)" />

    {/* Vizor */}
    <rect x="34" y="50" width="52" height="26" rx="13" fill="#1C2B3A" />

    {/* Gozler */}
    <rect x="43" y="56" width="10" height="14" rx="5" fill="#FFFFFF" />
    <rect x="67" y="56" width="10" height="14" rx="5" fill="#FFFFFF" />

    {/* Gulus */}
    <path
      d="M47 84 Q60 94 73 84"
      stroke="#F7844F"
      strokeWidth="5"
      strokeLinecap="round"
      fill="none"
    />

    <defs>
      <linearGradient id="headGrad" x1="60" y1="28" x2="60" y2="98" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#82CFEA" />
        <stop offset="100%" stopColor="#4BA6D6" />
      </linearGradient>
    </defs>
  </svg>
);

export default RobotIcon;
